export default "<p>shipping works!</p>\n";